export default __webpack_public_path__ + "static/media/timer.c0407c61.svg";